import React from 'react';

// DEPENDENCIES
import { useSelector } from 'react-redux';
import { compose } from 'redux';

// GLOBAL VARIABLES
import { ENDPOINTS } from 'endpoints.js';

// HELPERS
import { getLookupData } from 'helpers/getLookupData';
import useRecordView from 'helpers/getRecordView';

// CORE COMPONENTS
import Form from 'core/form/Form';

// GLOBAL PARTS
import Card from 'parts/card/Card';
import Record from 'parts/record/Record';

// FUNCTIONS
const formatRecord = ({
  date_created,
  date_updated,
  created_user,
  udpated_user,
  ...record
} = {}) => record;

// MAIN COMPONENT
const Update = () => {

  // CONTEXT
  const { isGlobal } = useRecordView();

  // REDUX
  const dealership = useSelector(({ dealership }) => dealership);

  // RENDER
  return (
    <Record.Update
      recordLabel="report"
      endpoints={ENDPOINTS.admin.reports}
      method="POST"
      initialValues={{
        is_active: 1,
        is_global: isGlobal ? 1 : 0,
        make_dealer_id: dealership
      }}
      formatRecord={formatRecord}
    >
      <Card
        body={<FormBody/>}
      />
    </Record.Update>
  )

};

const FormBody = () => (
  <Form.Body>
    <Form.Control
      name="report_title"
      label="Title"
      required
    />
    <Form.Select
      name="report_category_ids"
      label="Categories"
      lookup="reportCategory"
      optionKeys={{
        label: 'report_category_name',
        value: 'report_category_id'
      }}
      multiple
      useCSV={false}
      required
    />
    <Form.YesNo
      name="is_global"
      label="Global"
      plaintext
      required
    />
    <Form.YesNo
      name="is_active"
      label="Active"
      numeric
      required
    />
    <Card.Divider />
    <Form.Table
      name="report_fields"
      title="Report Content"
      itemLabel="Field"
      min={1}
    >{() => [
      <Form.Select
        name="aggregate_function"
        label="Function"
        lookup="reportAggregateFunction"
        useLookup={false}
        colWidth={3}
        useNone
      />,
      <Form.Select
        name="field_id"
        label="Field"
        lookup="reportField"
        optionKeys={{
          group: 'object_label_plural',
          value: 'field_id',
          label: 'field_label'
        }}
        useLookup={false}
        colWidth={8}
        required
      />
    ]}</Form.Table>
    <Card.Divider />
    <Form.Table
      name="report_filters"
      title="Filters (Optional)"
      itemLabel="Filter"
    >{() => [
      <Form.Select
        name="field_type"
        label="Type"
        lookup="reportFilterTypes"
        optionKeys={{
          value: 'value',
          label: 'name'
        }}
        colWidth={3}
        useCSV={false}
        required
      />,
      <Form.Select
        name="aggregate_function"
        label="Function"
        lookup="reportAggregateFunction"
        useLookup={false}
        colWidth={3}
        useNone
      />,
      <Form.Select
        name="field_id"
        label="Field"
        lookup="reportField"
        optionKeys={{
          group: 'object_label_plural',
          value: 'field_id',
          label: 'field_label'
        }}
        useLookup={false}
        colWidth={8}
        required
      />,
      <Form.Select
        name="filter_operation"
        label="Operation"
        lookup="reportFilterOperations"
        optionKeys={{
          value: 'value',
          label: 'description'
        }}
        useLookup={false}
        colWidth={4}
        required
      />,
      <Form.Control
        name="filter_value"
        label="Value"
        placeholder="C,D"
        colWidth={6}
        required
      />
    ]}</Form.Table>
    <Record.Log />
  </Form.Body>
);

// EXPORT
export default compose(
  getLookupData({
    lookup: [
      'reportAggregateFunction',
      'reportField',
      'reportFilterOperations'
    ]
  })
)(Update);
